import React from "react";
import { Link } from "react-router-dom";

const Banner = () => {
  return (
    <>
      <div id="home" className="h-banner">
        <div id="scrollTop" className="banner-content mt-5 ">
          <div className="content-main">
            <div className="banner-heading">
              <p>Transform Your Construction </p>
              <p>
                {" "}
                With <span>Group LanDev AI</span>
              </p>
              <p className="para-text mb-5">
              Discover a new era in construction, seamlessly blending creativity and cutting-edge technology!
              </p>
            </div>
            <Link to="/dashboard">
              <button className="login-btn mb-5">Start with AI</button>
            </Link>
          </div>
        </div>
        <div className="banner-vid">
          <video loop autoPlay playsInline muted>
            <source src="../../../videos/homeVideo.mp4" type="video/mp4" />
          </video>
        </div>

        <div className="gray-layer"></div>
      </div>
    </>
  );
};

export default Banner;
